const attributesToTrackClick = Object.freeze({
    'data-action': 'ctr'
})

const attributesToTrackClickKeys = Object.freeze(Object.keys(attributesToTrackClick))

export {
    attributesToTrackClick,
    attributesToTrackClickKeys
}